import styles from '../../styles/BenefitLabel.module.css'
import { useEffect, useState } from "react";

const BenefitLabel = (props: { content: string, backgroundColor?: string }) => {

  const [backgroundColor, setBackgroundColor] = useState<string | null>(null)

  useEffect(() => {
    if (props.backgroundColor) setBackgroundColor(props.backgroundColor)
  }, [props.backgroundColor])

  if (!props.content) return <></>

  return(
    <span
      className={`px-2 py-1 me-2 mb-2 sentenceCase ${styles.container}`}
      style={{ ...(backgroundColor ? { backgroundColor } : {}) }}
    >
      {props.content}
    </span>
  )
}

export default BenefitLabel